import { render, staticRenderFns } from "./updatePasswordModal.vue?vue&type=template&id=20be0870&scoped=true&"
import script from "./updatePasswordModal.vue?vue&type=script&lang=js&"
export * from "./updatePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePasswordModal.vue?vue&type=style&index=0&id=20be0870&prod&lang=less&scoped=true&"
import style1 from "./updatePasswordModal.vue?vue&type=style&index=1&id=20be0870&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be0870",
  null
  
)

export default component.exports